import { dropdownMenuWrapperCSS } from '@ardoq/dropdown-menu-ui';
import { colors, s32, s8, timeFastMs } from '@ardoq/design-tokens';
import styled, { css } from 'styled-components';
import { FlexBox, Stack } from '@ardoq/layout';

export const DatePickerDropdownWrapper = styled.div<{ $isVisible?: boolean }>`
  ${
    // TODO: get rid of "any"
    dropdownMenuWrapperCSS as any
  };
  padding: 0;
  width: 310px;
  max-height: 365px;

  /* ANIMATION */
  transition:
    opacity ${timeFastMs},
    transform ${timeFastMs};
  ${({ $isVisible = true }) =>
    $isVisible
      ? css`
          opacity: 1;
          transform: translateY(0);
        `
      : css`
          opacity: 0;
          transform: translateY(-20px);
        `}
`;

export const DatePickerDropdownHeaderFooter = styled(FlexBox).attrs({
  justify: 'space-evenly',
  paddingY: 'small',
  gap: 'medium',
})`
  padding: ${s8} 0;
  border-bottom: 1px solid ${colors.borderSubtle};
  &:last-child {
    border-bottom: none;
  }
`;

export const DatePickerDropdownBody = styled(Stack).attrs({
  justify: 'center',
})`
  border-bottom: 1px solid ${colors.borderSubtle};
  padding: 0 ${s32};
  height: 264px;
`;
